<template>
   <div class="container" v-if="show">
     <img src="https://picture.shjyyyxx.com/image/gongogngongtouxiang.jpg" class="errorImg" alt="">
   </div>
</template>
<script>
export default {
   name: 'Error',
   mixins: [],
   props: {
     showTime:{
        type: Number,
        default: 3000
     }
   },
   data() {
     return {
       show:true
     }
   },
   created(){
    this.timer = setTimeout(()=>{
        clearTimeout(this.timer)
        this.show = false
    },this.showTime)
   },
};
</script>
<style lang='scss' scoped>
.container{
    width: 100vw;
    height: 100vh;
    background-color: #00000050;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999999;
    .errorImg{
        width: 40%;

    }
}

</style>